import { render, staticRenderFns } from "./order-modal-assign-creator.vue?vue&type=template&id=a4d264b6&scoped=true"
import script from "./order-modal-assign-creator.vue?vue&type=script&lang=js"
export * from "./order-modal-assign-creator.vue?vue&type=script&lang=js"
import style0 from "./order-modal-assign-creator.vue?vue&type=style&index=0&id=a4d264b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d264b6",
  null
  
)

export default component.exports